import { db } from './supabase'

export const api = {
  getContent: () => db.getContent(),
  updateContent: (data) => db.updateContent(data),
  getItems: () => db.getItems(),
  getAllItems: () => db.getAllItems(),
  getItem: (slug) => db.getItem(slug),
  upsertItem: (item) => db.upsertItem(item),
  deleteItem: (slug) => db.deleteItem(slug),
  getGallery: () => db.getGallery(),
  upsertGallery: (item) => db.upsertGallery(item),
  deleteGallery: (id) => db.deleteGallery(id),
  getReservations: () => db.getReservations(),
  upsertReservation: (res) => db.upsertReservation(res),
  updateReservation: (id, data) => db.updateReservation(id, data),
  deleteReservation: (id) => db.deleteReservation(id),
  getReviews: () => db.getReviews(),
  getAllReviews: () => db.getAllReviews(),
  upsertReview: (rev) => db.upsertReview(rev),
  updateReview: (id, data) => db.updateReview(id, data),
  deleteReview: (id) => db.deleteReview(id),
}

export default api
